
// Canadian area codes as of 2024
const CANADIAN_AREA_CODES = [
  '204', '226', '236', '249', '250', '289', '306', '343', '365', '367',
  '368', '382', '403', '416', '418', '428', '431', '437', '438', '450',
  '506', '514', '519', '548', '579', '581', '587', '604', '613', '639',
  '647', '672', '705', '709', '742', '778', '780', '782', '807', '819',
  '825', '867', '873', '902', '905'
];

export const formatPhoneNumber = (phone: string): string => {
  // Remove all non-numeric characters
  const cleaned = phone.replace(/\D/g, '');
  
  // Remove leading "1" if present and we have 11 digits
  const withoutCountryCode = cleaned.length === 11 && cleaned.startsWith('1') 
    ? cleaned.slice(1) 
    : cleaned;
  
  // Format as (XXX) XXX-XXXX for 10 digit numbers
  if (withoutCountryCode.length === 10) {
    return `(${withoutCountryCode.slice(0, 3)}) ${withoutCountryCode.slice(3, 6)}-${withoutCountryCode.slice(6)}`;
  }
  
  // Return original if not 10 digits after processing
  return phone;
};

export const validateCanadianAreaCode = (phone: string): boolean => {
  const cleaned = phone.replace(/\D/g, '');
  const withoutCountryCode = cleaned.length === 11 && cleaned.startsWith('1') 
    ? cleaned.slice(1) 
    : cleaned;
  
  if (withoutCountryCode.length >= 3) {
    const areaCode = withoutCountryCode.slice(0, 3);
    return CANADIAN_AREA_CODES.includes(areaCode);
  }
  
  return false;
};

export const validatePhoneNumber = (phone: string): boolean => {
  const cleaned = phone.replace(/\D/g, '');
  const withoutCountryCode = cleaned.length === 11 && cleaned.startsWith('1') 
    ? cleaned.slice(1) 
    : cleaned;
  
  return withoutCountryCode.length === 10;
};

export const validateCanadianPhoneNumber = (phone: string): { isValid: boolean; error?: string } => {
  if (!phone || phone.trim() === '') {
    return { isValid: false, error: 'Phone number is required' };
  }
  
  const cleaned = phone.replace(/\D/g, '');
  const withoutCountryCode = cleaned.length === 11 && cleaned.startsWith('1') 
    ? cleaned.slice(1) 
    : cleaned;
  
  if (withoutCountryCode.length !== 10) {
    return { isValid: false, error: 'Phone number must be 10 digits' };
  }
  
  const areaCode = withoutCountryCode.slice(0, 3);
  if (!CANADIAN_AREA_CODES.includes(areaCode)) {
    return { isValid: false, error: 'Area code is not valid for Canada' };
  }
  
  return { isValid: true };
};
